module.exports = __webpack_public_path__ + "img/success-case-2.c6959d2f.png";